<template>
  <cv-content id="main-content" style="width: 100vw;">
    <cv-data-table :columns="colonne"
                   :data="righe"
                   title="Province"
                   helper-text="Elenco delle province italiane" />
  </cv-content>
</template>

<script>
export default {
  name: "Province",
  data: function() {
    return {
      colonne: [
        "Descrizione",
        "Sigla"
      ],
      righe: [
        [
          "Ferrara", "FE"
        ],
        [
          "Ravenna", "RA"
        ],
        [
          "Trento", "TN"
        ],
      ]
    }
  }
}
</script>

<style scoped>

</style>